import { render, staticRenderFns } from "./OfflineOrder.vue?vue&type=template&id=5cb0ff2c&scoped=true&"
import script from "./OfflineOrder.vue?vue&type=script&lang=js&"
export * from "./OfflineOrder.vue?vue&type=script&lang=js&"
import style0 from "./OfflineOrder.vue?vue&type=style&index=0&id=5cb0ff2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0ff2c",
  null
  
)

export default component.exports